export default __webpack_public_path__ + "static/media/incomeSurrogate.5386681d.png";